import React from "react";

const PaymentsSummaryCard = ({
  totalAmount = 0,
  totalBookings = 0,
  verifiedAmount = 0,
  verifiedCount = 0,
  unverifiedAmount = 0,
  unverifiedCount = 0,
}) => {
  const avgOrderValue =
    verifiedCount + unverifiedCount > 0
      ? Math.round(
          (verifiedAmount + unverifiedAmount) /
            (verifiedCount + unverifiedCount)
        )
      : 0;

  return (
    <div className="w-[95%] xl:w-1/3 bg-[#FBB033] rounded-3xl p-7 flex flex-col gap-6 shadow-lg">
      {/* Header */}
      <div className="flex items-center gap-4">
        <img
          src="/Assets/dashboard-1.png"
          alt="Earnings"
          className="w-11 h-11"
        />
        <div>
          <p className="text-[#39354E] text-sm font-medium">Total Earnings</p>
          <p className="text-[#39354E] text-2xl font-bold">₹ {totalAmount}</p>
        </div>
      </div>

      {/* Divider */}
      <div className="w-full h-[1px] bg-[#ECF1FF]" />

      {/* Verified */}
      <div className="bg-white rounded-xl p-4 flex justify-between items-center">
        <div>
          <p className="text-green-600 text-sm font-semibold">
            Verified Payments
          </p>
          <p className="text-xs text-gray-500">{verifiedCount} bookings</p>
        </div>
        <p className="text-[#39354E] font-bold text-lg">₹ {verifiedAmount}</p>
      </div>

      {/* Unverified */}
      <div className="bg-white/80 rounded-xl p-4 flex justify-between items-center">
        <div>
          <p className="text-amber-600 text-sm font-semibold">
            Unverified Payments
          </p>
          <p className="text-xs text-gray-500">{unverifiedCount} bookings</p>
        </div>
        <p className="text-[#39354E] font-bold text-lg">₹ {unverifiedAmount}</p>
      </div>

      {/* Divider */}
      <div className="w-full h-[1px] bg-[#ECF1FF]" />

      {/* Average Order Value */}
      <div className="bg-[#39354E] rounded-xl p-4 flex justify-between items-center">
        <div>
          <p className="text-white text-sm font-semibold">Avg Order Value</p>
          <p className="text-xs text-white/70">
            Based on {unverifiedCount + verifiedCount} bookings
          </p>
        </div>
        <p className="text-white font-bold text-lg">₹ {avgOrderValue}</p>
      </div>
    </div>
  );
};

export default PaymentsSummaryCard;
